import type * as C from "@zooi/contracts";

// How the inbox groups what waits (docs/design-system.md §0.4, plan M7 step
// 7g), kept apart from the components so the rule is tested: decisions first,
// then runs to start, then notices. The server's order holds within a group.

export const INBOX_GROUPS = ["needs_you", "next", "notices"] as const;
export type InboxGroup = (typeof INBOX_GROUPS)[number];

const GROUP: Record<C.InboxItem["kind"], InboxGroup> = {
  plan: "needs_you", work_order: "needs_you", post: "needs_you", outreach: "needs_you", reply_queue: "needs_you", reading: "needs_you", campaign_reading: "needs_you", fact_review: "needs_you", rule_review: "needs_you", data_setup: "needs_you", connection_failing: "needs_you", feedback: "needs_you",
  run_request: "next", merge: "next",
  run_missed: "notices", runs_degraded: "notices", connection: "notices", plans_idle: "notices", product_idle: "notices", run_stalled: "notices",
};

export const groupOf = (item: Pick<C.InboxItem, "kind">): InboxGroup => GROUP[item.kind] ?? "notices";

/** The non-empty groups in order, each with its items; `flat` is the order J and K move in. */
export function groupInbox<T extends Pick<C.InboxItem, "kind">>(items: readonly T[]): { groups: { group: InboxGroup; items: T[] }[]; flat: T[] } {
  const groups = INBOX_GROUPS.map((group) => ({ group, items: items.filter((item) => groupOf(item) === group) })).filter((entry) => entry.items.length > 0);
  return { groups, flat: groups.flatMap((entry) => entry.items) };
}
